import { verify } from "crypto";
import { Event } from "../models/Event";
import { clean } from "../utils/utils";
import api from "./api"; // the custom Axios instance

const PATH = "/api/v1/events";

export const EventService = {
  async createEvent(
    eventData: Omit<Event, "_id" | "createdAt" | "updatedAt">,
  ): Promise<string> {
    const response = await api.post(PATH, clean(eventData));
    return response.data.data._id;
  },

  async getEvent(eventId: string): Promise<Event> {
    const response = await api.get(`${PATH}/${eventId}`);
    return response.data.data; // Return null if no data found
  },

  async updateEvent(
    eventId: string,
    updatedData: Partial<Omit<Event, "_id" | "createdAt">>,
  ): Promise<void> {
    await api.put(`${PATH}/${eventId}`, clean(updatedData));
  },

  async deleteEvent(eventId: string): Promise<void> {
    await api.delete(`${PATH}/${eventId}`);
  },

  async verifyEvent(eventId: string): Promise<void> {
    await api.post(`${PATH}/${eventId}/verify`);
  },
};
